<template>
  <div>
    <Header />
    <main>
      <div class="form-container">
        <div class="contact-form">
          <div class="payment-status success">
            <i class="fas fa-check-circle" style="font-size: 3rem; margin-bottom: 1rem;"></i>
            <h2>Thank You For Your Purchase!</h2>
            <p>Your payment has been successfully processed.</p>
            <div class="order-details">
              <p><strong>Order Tracking ID (Save This!):</strong> {{ orderId }}</p>
            </div>
          </div>

          <div class="next-steps">
            <p>For any questions regarding your order, please contact our support team.</p>
          </div>

          <button class="next-btn" type="button" @click="goToHome">Back to Shop</button>
        </div>

        <div class="order-summary">
          <h2>Order Details</h2>
          <div class="order-info">
            <p><strong>Order ID:</strong> {{ orderId }}</p>
            <p><strong>Date:</strong> {{ currentDate }}</p>
            <p><strong>Status:</strong> <span class="status-badge">Completed</span></p>
          </div>

          <ul v-if="this.kits && this.kits.length">
            <li v-for="(item, index) in this.kits" :key="index" class="order-item">
              <img :src="item.image" alt="Product Image" class="item-image" />
              <strong>{{ item.name }} x{{ item.quantity }} - ${{ (item.price * item.quantity).toFixed(2) }}</strong>
            </li>
          </ul>
          <div v-else class="placeholder-message">
            <p>Your order details will appear here shortly...</p>
          </div>

          <div class="total-price">
            <strong>Total Paid:</strong> ${{ totalAmount }}
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from "@/views/Header/Header.vue";
import {doc, updateDoc} from "firebase/firestore";
import {db} from "@/firebase";

export default {
  name: 'SuccessPage',
  components: {Header},
  data() {
    return {
      orderId: '',
      paymentMethod: '',
      kits: [],
      currentDate: '',
      totalAmount: '0.00'
    }
  },
  computed: {
    ...mapGetters(['cart'])
  },
  async created() {
    this.orderId = this.$route.query.orderid || 'N/A';
    this.paymentMethod = this.$route.query.method || 'N/A';

    if(this.paymentMethod !== 'N/A' && this.paymentMethod === "Crypto"){
      try {

        const orderRef = doc(db, 'payments', this.orderId);
        await updateDoc(orderRef, {
          stage: "payment"
        });

      } catch (error) {
        console.error('Error updating coordinates:', error);
      }
    }

    const now = new Date();
    this.currentDate = now.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    this.kits = this.cart
    this.totalAmount = this.$route.query.amount ||
        (this.cart ? this.cart.reduce((acc, item) => acc + (item.price * item.quantity), 0).toFixed(2) : '0.00');
    this.$store.commit('clearCart');
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  padding: 0 1rem;
}

.form-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 2rem;
  margin-top: 3%;
  justify-content: center;
  flex-wrap: wrap;
}

.contact-form {
  flex: 1;
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  min-width: 300px;
  max-width: 600px;
}

.order-summary {
  flex: 1;
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  min-width: 300px;
  max-width: 500px;
}

.order-summary h2 {
  font-size: 1.6rem;
  color: cornflowerblue;
  margin-bottom: 1rem;
}

.order-summary ul {
  list-style: none;
  padding: 0;
}

.order-summary li {
  margin-bottom: 0.7rem;
  font-size: 1.1rem;
  color: #ccc;
  display: flex;
  align-items: center;
}

.order-summary .item-image {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  object-fit: cover;
}

.order-info {
  background-color: #333;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.order-info p {
  margin: 0.5rem 0;
}

.status-badge {
  background-color: #27ae60;
  color: white;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
}

.total-price {
  margin-top: 1rem;
  font-size: 1.3rem;
  font-weight: bold;
  color: cornflowerblue;
}


.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
}

.payment-status {
  margin-top: 1rem;
  padding: 2rem;
  border-radius: 6px;
  text-align: center;
}

.payment-status.success {
  background-color: rgba(39, 174, 96, 0.2);
  border: 1px solid #27ae60;
  color: #2ecc71;
}

.payment-status h2 {
  color: #2ecc71;
  margin-bottom: 1rem;
}

.order-details {
  margin-top: 1.5rem;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 1rem;
  border-radius: 6px;
}

.next-steps {
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  color: #ddd;
  text-align: center;
}

.next-btn {
  margin-top: 1rem;
  padding: 0.8rem 2rem;
  background-color: cornflowerblue;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
  width: 100%;
}

.next-btn:hover {
  background-color: royalblue;
}

.placeholder-message {
  background-color: #333;
  padding: 1rem;
  border-radius: 6px;
  font-style: italic;
  color: #aaa;
  text-align: center;
}

@media (max-width: 768px) {
  .form-container {
    flex-direction: column;
    align-items: center;
  }

  .contact-form, .order-summary {
    width: 100%;
    max-width: 500px;
  }

  .order-summary {
    margin-top: 2rem;
  }
}
</style>